import React from 'react';
// mui
import { Box, Typography } from '@mui/material';
//components
import Voicemail from './Voicemail';
// interfaces
import { Voicemail as VoicemailInterface } from 'src/hooks/core-api/useVoicemail';
//
import { generateDayLabel, needsDayLabelGenerated } from '../shared/pagination-labels';

interface VoicemailListProps {
  voicemailListGroup: VoicemailInterface[];
  previousVoicemailListGroup: VoicemailInterface[]; // Pagination creates multiple page
}

const sortVoicemailList = (voicemailListGroup: VoicemailInterface[]) =>
  voicemailListGroup.sort(
    (a, b) => new Date(b.created_on).getTime() - new Date(a.created_on).getTime()
  );

const getDateFromArrayEnd = (
  voicemailListGroup: VoicemailInterface[],
  direction: 'start' | 'end'
) => {
  // Takes first or last element of call history group and returns it as a date
  const queryIndex = direction === 'start' ? 0 : voicemailListGroup.length - 1;
  const dateString = voicemailListGroup?.[queryIndex]?.created_on;

  if (voicemailListGroup.length === 0 || !dateString) {
    return null;
  }

  return new Date(dateString);
};

const VoicemailList: React.FC<VoicemailListProps> = ({
  voicemailListGroup,
  previousVoicemailListGroup,
}) => {
  // Because of pagination, we need to sort the previous and current call
  // history groups and see if a new day label is needed
  //
  // (previous groups may have items that are on the same day of items in the
  // current group)
  const sortedVoicemailList = sortVoicemailList(voicemailListGroup);
  const sortedPreviousVoicemailList = sortVoicemailList(previousVoicemailListGroup);
  const lastVoicemailListDate = getDateFromArrayEnd(sortedPreviousVoicemailList, 'end');
  let lastDate = lastVoicemailListDate; // Not using setState() because we don't want to re-render

  return (
    <>
      {sortedVoicemailList.map((voicemail, i) => {
        const currentLogDate = new Date(voicemail.created_on);
        const needsNewDayLabel = needsDayLabelGenerated(lastDate, currentLogDate);

        lastDate = new Date(voicemail.created_on);
        return (
          <React.Fragment key={i}>
            {needsNewDayLabel && (
              <Typography variant="h6" sx={{ my: 2 }}>
                {generateDayLabel(currentLogDate)}
              </Typography>
            )}
            <Box sx={{ py: 2, px: 1 }} key={i}>
              <Voicemail voicemail={voicemail} />
            </Box>
          </React.Fragment>
        );
      })}
    </>
  );
};

export default VoicemailList;
